"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-heal-icon.svg.js",
    _path,
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M25.6 0H6.4A6.4 6.4 0 000 6.4v19.2A6.4 6.4 0 006.4 32h19.2a6.4 6.4 0 006.4-6.4V6.4A6.4 6.4 0 0025.6 0z",
    fill: "url(#prefix__paint0_linear_5452_34922)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5452_34922)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.131 6.8a4.215 4.215 0 11.007 8.43 4.215 4.215 0 01-.007-8.43z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }), React.createElement("path", {
    d: "M4.46 12.915S2.878 23.548 15.87 25.308c0 0-.628-12.287-11.409-12.393z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }), React.createElement("path", {
    d: "M27.54 12.915s1.593 10.633-11.409 12.393c0 0 .635-12.287 11.409-12.393z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear_5452_34922",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#F7F7F7",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43
    },
    __self: this
  })), React.createElement("clipPath", {
    id: "prefix__clip0_5452_34922",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.4 6.8)",
    d: "M0 0h23.2v18.508H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;